import {
  Box,
  Button,
  Flex,
  Icon,
  Badge,
  Spacer,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useHistory,useLocation } from "react-router-dom";


function InvoicesRow(props) {
  const textColor = useColorModeValue("gray.700", "white");
const bgStatus = useColorModeValue("gray.400", "navy.900");
  const { active, title, logo,id,number,address } = props;
const history = useHistory();
  return (
    <Flex my={{ sm: "1rem", xl: "10px" }} alignItems="center">
      {(title)?
      <>
       <Flex direction="column">
        <Icon as={logo} w="20px" h="auto" me="5px" color={textColor}/>
      </Flex>
      <Flex direction="column">
        <Text fontSize="sm" color={textColor}>
        {title}
        </Text>
      </Flex>
      <Spacer />
      <Box me="12px">
      <Badge
          bg={active === true ? "green.400" : bgStatus}
          color={active === true ? "white" : "white"}
          fontSize="12px"
          p="3px 10px"
          borderRadius="8px"
        >
          {active==true?"فعال":"غیرفعال"}
        </Badge>
      </Box>
      <Button p="0px" bg="transparent" variant="no-effects">
        <Flex alignItems="center" p="12px">
        <Link onClick={()=>history.push("/admin/rooms/"+address+"/details/"+id)} p="0px" bg="transparent" variant="no-effects">
          <Text
            fontSize="xs"
            color="gray.400"
            fontWeight="bold"
            cursor="pointer"
          >
            ویرایش
          </Text>
        </Link>
        </Flex>
      </Button>
      </>:<>
      <Flex direction="column">
      </Flex>
      <Flex direction="column">
        <Text fontSize="sm" color={textColor}>
       {""}
        </Text>
      </Flex>
      <Spacer />
      <Box me="12px">
      <Badge
          bg="transparent"
          color={active === true ? "white" : "white"}
          fontSize="12px"
          p="3px 10px"
          borderRadius="8px"
        >
          {""}
        </Badge>
      </Box>
      <Button p="0px" bg="transparent" variant="no-effects">
        <Flex alignItems="center" p="12px">
        <Link  p="0px" bg="transparent" variant="no-effects">
          <Text
            fontSize="xs"
            color="gray.400"
            fontWeight="bold"
            cursor="pointer"
          >
            {""}
          </Text>
        </Link>
        </Flex>
      </Button>

      </>
      }
      
    </Flex>
  );
}

export default InvoicesRow;
